import isItemView from 'owa-mail-store/lib/utils/isItemView';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { setRsvpUnitAriaDetailsForItem } from 'owa-mail-store/lib/actions/setRsvpUnitAriaDetailsForItem';
import { setRsvpUnitAriaDetailsForTableConversation } from '../actions/setRsvpUnitAriaDetailsForTableConversation';

/**
 * Sets the rsvpUnitAriaDetails value of a row in mail list
 * @param tableViewId id of the tableView where the item/conversation resides
 * @param rowId id of item/conversation
 * @param rsvpUnitAriaDetails value to set
 */
export const setRsvpUnitAriaDetailsForMailListRow = (
    tableViewId: string,
    rowId: string,
    rsvpUnitAriaDetails: string
) => {
    const tableView = getListViewStore().tableViews.get(tableViewId);
    isItemView(tableView)
        ? setRsvpUnitAriaDetailsForItem(rowId, rsvpUnitAriaDetails)
        : setRsvpUnitAriaDetailsForTableConversation(rowId, tableViewId, rsvpUnitAriaDetails);
};
